<template>
    <div class="container">
        <md-dialog :md-active.sync="modalCrear" :md-click-outside-to-close="false">
            <md-dialog-title class="text-center">
                {{ labels.title }}
            </md-dialog-title>
            <md-dialog-content>
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.codigo}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="number" v-model="codigo" class="form-control">
                    </b-col>
                </b-row>
                <!-- <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.descripcion}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="text" v-model="descripcion" class="form-control">
                    </b-col>
                </b-row> -->
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.tipoActivo}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <select v-model="tipoActivo" class="form-control">
                            <option value="0">{{ labels.select }}</option>
                            <option v-for="tipActiv in listaTypeAct" :key="tipActiv.id" :value="tipActiv.tipo_activo">{{ tipActiv.descripcion }}</option>
                        </select>
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.proveedor}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <select v-model="proveedor" class="form-control">
                            <option value="0">{{ labels.select }}</option>
                            <option v-for="tercero in listaTerceros" :key="tercero.id" :value="tercero.identificacion">{{ tercero.nombre }}</option>
                        </select>
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.fechaCompra}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="date" v-model="fechaCompra" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.valorCompra}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="number" v-model="valorCompra" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.valorSalvamento}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="number" v-model="valorSalvamento" class="form-control">
                    </b-col>
                </b-row>
                <div class="" v-if="showListTipAct">
                    <b-row class="" v-for="caracteristica in caractActivo" :key="caracteristica.id">
                        <b-col cols="1"></b-col>
                        <b-col cols="5" class="text-left">
                            <h5>{{caracteristica.descripcion}}</h5>
                        </b-col>
                        <b-col cols="6" class="text-left">
                            <input type="text" :name="caracteristica.descripcion" v-model="listCaractAct[caracteristica.descripcion]" class="form-control caracteristica" :id="caracteristica.caracteristica">
                        </b-col>
                    </b-row>
                </div>
                <md-dialog-actions class="mt-3">
                    <md-button class="md-primary" @click="guardarActivo">{{ labels.save }}</md-button>
                    <md-button class="md-accent" @click="cierraModal">{{ labels.close }}</md-button>
                </md-dialog-actions>
            </md-dialog-content>
        </md-dialog>
    </div>
</template>

<script>

import TipoActivo from '../../services/TipoActivo'
import Tercero from '../../services/Tercero'
import Activo from '../../services/Activos'
import TipoActivoCaracteristica from '../../services/TipoActivoCaracteristica'

export default {
    name:'Crear',
    props:['modalCrear'],
    data:() => ({
        listaTypeAct : [],
        listaTerceros : [],
        codigo : null,
        // descripcion : '',
        tipoActivo : null,
        proveedor : null,
        fechaCompra : '',
        valorCompra : null,
        valorSalvamento : null,
        vidaUtil : '',
        showListTipAct : false,
        caractActivo : [],
        listCaractAct : {}
    }),
    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Crear activo",
                    codigo : "Código",
                    // descripcion : "Descripción",
                    tipoActivo : 'Tipo activo',
                    proveedor : 'Proveedor',
                    fechaCompra : 'Fecha compra',
                    valorCompra : 'Valor compra',
                    valorSalvamento : 'Valor salvamento',
                    save : "Guardar",
                    close : "Cerrar",
                    select : "Seleccione...",
                }
            }else{
                return {
                    title: "Create active",
                    codigo : "Code",
                    // descripcion : "Description",
                    tipoActivo : 'Active type',
                    proveedor : 'Provider',
                    fechaCompra : 'Purchase date',
                    valorCompra : 'Purchase value',
                    valorSalvamento : 'Salvage value',
                    save : "Sava",
                    close : "Close",
                    select : "Select...",
                }
            }
        }
    },
    methods:{
        cierraModal(){
            this.$emit('cierraModal',false)
        },
        guardarActivo(){

            const inputs = document.querySelectorAll('.caracteristica')
            const listCaract = [];
            let objCaract = {}
            inputs.forEach(input => {
                objCaract = {
                    'codCaracteristica' : input.id,
                    'infoCaracterist' : input.name,
                    'caracteristica' : input.value,
                }
                listCaract.push(objCaract);
            });

            for (let key in objCaract) {
                // Verifica si el valor es vacío
                if (objCaract[key] === null || objCaract[key] === undefined || objCaract[key] === '') {
                    this.$toast.error('Caracteristica(s) pendiente(s) por diligenciar')
                    return
                }
            }

            const valForm = [
                this.codigo,
                // this.descripcion,
                this.tipoActivo,
                this.proveedor,
                this.fechaCompra,
                this.valorCompra,
                this.valorSalvamento
            ]

            if(valForm.includes('')){
                this.$toast.error('Campo(s) pendiente(s) por diligenciar')
            }else{
                let info = {
                    'codActivo' : this.codigo,
                    // 'descripcion' : this.descripcion,
                    'tipo_activo' : this.tipoActivo,
                    'proveedor' : this.proveedor,
                    'fecha_compra' : this.fechaCompra,
                    'valor_compra' : this.valorCompra,
                    'valor_salvamento' : this.valorSalvamento,
                    'idUser' : this.$store.state.userId,
                    'caract_activo' : listCaract
                }

                Activo.createActivo(info)
                .then((res) => {

                    if(res.status == 201){
                        this.$toast.success(res.data.message)
                        location. reload()
                    
                    }else if(res.status == 204){
                        this.$toast.error('Activo ingresado ya existe.')
                    }
                })
                .catch((error) => error)
            }
        }
    },
    mounted(){
        TipoActivo.getAllTipoActivo()
        .then((res) => {
            // console.log(res.data.listTipoActivo)
            this.listaTypeAct = res.data.listTipoActivo
            this.showListTipAct = true
        })
        .catch((err) => { console.log(err) })

        Tercero.getAllTercero()
        .then((res) => {
            // console.log(res.data.listTercero);
            this.listaTerceros = res.data.listTercero
        })
    },
    watch:{
        tipoActivo(valNew){
            // console.log(valNew);
            TipoActivoCaracteristica.getTipoActivoCaractByTipAct(valNew)
            .then((res) => {
                // console.log(res.data.tipActCar);
                this.caractActivo = res.data.tipActCar
            })
            .catch((err) => {console.log(err);})
        }
    }
}
</script>

<style>

</style>